var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_163_6405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.90005 14.1001L7.99005 14.0101C8.26005 13.7401 8.31005 13.3001 8.07005 13.0001C7.36005 12.0901 7.00005 11.0101 7.00005 10.0001C7.00005 8.92008 7.35005 7.84008 8.04005 6.99008C8.29005 6.69008 8.25005 6.24008 7.97005 5.97008L7.90005 5.90009C7.56005 5.56009 7.00005 5.60008 6.70005 5.98008C5.79005 7.16008 5.30005 8.58008 5.30005 10.0001C5.30005 11.4201 5.79005 12.8401 6.70005 14.0201C7.00005 14.4001 7.56005 14.4401 7.90005 14.1001Z",
    fill: "#4E5968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.51 3.49005L18.43 3.57005C18.13 3.87005 18.14 4.33005 18.4 4.65005C19.66 6.18005 20.3 8.13005 20.3 10.0001C20.3 11.8701 19.67 13.8101 18.4 15.3501C18.12 15.6801 18.17 16.18 18.48 16.4901C18.83 16.8401 19.41 16.8001 19.72 16.4201C21.29 14.5401 22 12.3101 22 10.0001C22 7.68005 21.21 5.45005 19.69 3.57005C19.39 3.20005 18.84 3.16005 18.51 3.49005Z",
    fill: "#4E5968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57 3.57005L5.49 3.49005C5.16 3.16005 4.61 3.20005 4.31 3.57005C2.79 5.45005 2 7.68005 2 10.0001C2 12.3201 2.79 14.5501 4.31 16.4301C4.61 16.8001 5.16 16.8501 5.49 16.5101L5.57 16.4301C5.87 16.1301 5.86 15.6701 5.6 15.3501C4.33 13.8101 3.7 11.8701 3.7 10.0001C3.7 8.13005 4.33 6.19005 5.6 4.65005C5.86 4.33005 5.87 3.87005 5.57 3.57005Z",
    fill: "#4E5968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.07 14.0701C16.43 14.4301 17.02 14.3901 17.33 13.9801C18.23 12.8001 18.7 11.4001 18.7 10.0001C18.62 8.59011 18.19 7.17011 17.3 5.99011C17.01 5.60011 16.44 5.56011 16.1 5.90011L16.02 5.98011C15.75 6.25011 15.7 6.69011 15.94 6.99011C16.64 7.91011 17 8.99011 17 10.0001C17 11.0701 16.66 12.1301 15.99 12.9801C15.73 13.3001 15.77 13.7701 16.07 14.0701Z",
    fill: "#4E5968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 10.0001C14.5 8.40011 12.99 7.15011 11.32 7.59011C10.52 7.80011 9.86004 8.44011 9.62004 9.24011C9.30004 10.3001 9.68004 11.2801 10.38 11.8801L7.42004 20.7501C7.21004 21.3701 7.67004 22.0001 8.32004 22.0001C8.73004 22.0001 9.09004 21.7401 9.22004 21.3501L9.67004 20.0001H14.34L14.79 21.3501C14.92 21.7401 15.28 22.0001 15.69 22.0001C16.34 22.0001 16.79 21.3701 16.59 20.7501L13.63 11.8801C14.16 11.4201 14.5 10.7601 14.5 10.0001ZM10.33 18.0001L12 13.0001L13.67 18.0001H10.33Z",
    fill: "#4E5968"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_163_6405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHub);
export default __webpack_public_path__ + "static/media/Hub.478a38b757cf7ffcc1ab4aed37e4a508.svg";
export { ForwardRef as ReactComponent };